import Plan from "./plan";
import Form from "./form";
import "../CSS/contact-us-2.css";
function ContactUs2() {
    return (
        <div className="contact-us-2">
            <Plan />
            <Form />
        </div>
    )
}
export default ContactUs2;